class BrPrintDirectoryFilter {
  constructor(root) {
    this.root = root;
    this.buttons = Array.from(root.querySelectorAll('[data-br-filter-button]'));
    this.status = root.querySelector('[data-br-filter-status]');

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    root.addEventListener('click', this.onClick);
    root.addEventListener('keydown', this.onKeydown);

    const activeButton = this.buttons.find((button) => button.getAttribute('aria-pressed') === 'true');
    this.activate(activeButton || this.buttons[0], false);
  }

  getDirectory() {
    return document.querySelector('[data-br-collection-directory]');
  }

  getHandles(button) {
    return new Set(
      (button?.dataset.brFilterHandles || '')
        .split('|')
        .map((handle) => handle.trim())
        .filter(Boolean),
    );
  }

  activate(button, moveFocus = false) {
    if (!button) return;

    const selectedHandles = this.getHandles(button);
    const directory = this.getDirectory();

    this.buttons.forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
      item.tabIndex = isActive ? 0 : -1;
    });

    let visibleCount = 0;

    if (directory) {
      const cards = Array.from(directory.querySelectorAll('[data-br-directory-card]'));
      const groups = Array.from(directory.querySelectorAll('[data-br-directory-group]'));

      cards.forEach((card) => {
        const shouldShow = selectedHandles.size === 0 || selectedHandles.has(card.dataset.brCollectionHandle);
        card.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-br-directory-card]:not([hidden])');
      });
    }

    if (this.status) {
      const label = button.dataset.brFilterLabel || button.textContent.trim();
      if (selectedHandles.size === 0) {
        this.status.textContent = 'Showing all collections.';
      } else if (visibleCount === 0) {
        this.status.textContent = `No collections found for ${label}.`;
      } else {
        this.status.textContent = `Showing ${visibleCount} ${label} ${visibleCount === 1 ? 'collection' : 'collections'}.`;
      }
    }

    if (moveFocus) button.focus();
  }

  onClick(event) {
    const button = event.target.closest('[data-br-filter-button]');
    if (!button || !this.root.contains(button)) return;
    this.activate(button);
  }

  onKeydown(event) {
    const currentIndex = this.buttons.indexOf(event.target);
    if (currentIndex < 0) return;

    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.buttons.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.buttons.length - 1;

    if (nextIndex === currentIndex && !['Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    this.activate(this.buttons[nextIndex], true);
  }
}

function initBrPrintDirectoryFilters(scope = document) {
  const roots = [];

  if (scope.matches?.('[data-br-print-filter]')) roots.push(scope);
  roots.push(...scope.querySelectorAll('[data-br-print-filter]'));

  roots.forEach((root) => {
    if (root.dataset.brPrintFilterReady === 'true') return;
    root.dataset.brPrintFilterReady = 'true';
    new BrPrintDirectoryFilter(root);
  });
}

initBrPrintDirectoryFilters();

document.addEventListener('shopify:section:load', (event) => {
  initBrPrintDirectoryFilters(event.target);

  document.querySelectorAll('[data-br-print-filter]').forEach((root) => {
    const activeButton = root.querySelector('[data-br-filter-button][aria-pressed="true"]');
    activeButton?.click();
  });
});

document.addEventListener('shopify:block:select', (event) => {
  const button = event.target.closest?.('[data-br-print-filter] [data-br-filter-button]');
  if (button) button.click();
});
